// Shared avatar color utility
// Single source of truth for all user avatar color options

export interface AvatarColorOption {
  name: string;
  bg: string;
  text: string;
}

export const AVATAR_COLORS: AvatarColorOption[] = [
  { name: 'Default', bg: 'hsl(var(--primary) / 0.1)', text: 'hsl(var(--primary))' },
  { name: 'Blue', bg: 'hsl(217 91% 60% / 0.2)', text: 'hsl(217 91% 60%)' },
  { name: 'Violet', bg: 'hsl(262 83% 58% / 0.2)', text: 'hsl(262 83% 58%)' },
  { name: 'Emerald', bg: 'hsl(142 76% 36% / 0.2)', text: 'hsl(142 76% 36%)' },
  { name: 'Orange', bg: 'hsl(30 100% 50% / 0.2)', text: 'hsl(30 100% 50%)' },
  { name: 'Pink', bg: 'hsl(340 82% 52% / 0.2)', text: 'hsl(340 82% 52%)' },
  { name: 'Cyan', bg: 'hsl(188 94% 43% / 0.2)', text: 'hsl(188 94% 43%)' },
  { name: 'Red', bg: 'hsl(0 84% 60% / 0.2)', text: 'hsl(0 84% 60%)' },
];

/**
 * Get avatar color by name.
 * Returns the matching color option or the default if not found.
 */
export const getAvatarColor = (colorName?: string | null): AvatarColorOption => {
  if (!colorName) return AVATAR_COLORS[0];
  return AVATAR_COLORS.find(c => c.name === colorName) || AVATAR_COLORS[0];
};

/**
 * Maximum avatar file size in bytes (5MB)
 */
export const MAX_AVATAR_SIZE = 5 * 1024 * 1024;

/**
 * Allowed avatar file types
 */
export const ALLOWED_AVATAR_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
